import React from 'react'
import { Alert, Intent } from '@blueprintjs/core'
import { useTranslation } from 'react-i18next'
import DOMPurify from 'dompurify'
const BPAlert = React.memo(({ type, message, isOpen, onClose, onAccept, acceptButtonText, onCancel, cancelButtonText, htmlContent }) => {
  const { t } = useTranslation()

  const handleOnClose = () => {
    onClose && onClose()
  }

  const handleOnAccept = () => {
    onAccept && onAccept()
  }

  const handleOnCancel = () => {
    onCancel && onCancel()
  }

  return (
    <Alert
      cancelButtonText={onCancel ? cancelButtonText || t('cancel') : null}
      confirmButtonText={acceptButtonText || t('ok')}
      icon={type === 'error' ? 'warning-sign' : type === 'confirm' ? 'confirm' : type === 'success' ? 'tick' : 'info-sign'}
      intent={type === 'error' ? Intent.DANGER : Intent.PRIMARY}
      isOpen={isOpen}
      onClose={handleOnClose}
      onConfirm={handleOnAccept}
      onCancel={handleOnCancel}
      style={{ maxHeight: 'calc( 100vh - 90px)', overflow: 'auto' }}
      className='thin-scroolbar'
    >
      {htmlContent && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlContent) }} />}
      {message && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }} />}
      {/* <div>{htmlContent ? <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlContent) }} /> : message}</div> */}
    </Alert>
  )
})

export default BPAlert
